import React from "react";
import "../styles/experience.css";
import Marque from "./Marque";
import BigText from "./BigText";
import AddExp from "./AddExp";
import Ksquare from "../images/ksquare.png";
import Wellytics from "../images/wellytics.png";
import Enligence from "../images/enligence.png";
import OasisInfobyte from "../images/oasisinfobyte.png";
import ImageMotion from "./ImageMotion";

import GlowShade from "./GlowShade";

export default function Experience() {
  return (
    <div className="experience">
      <Marque text={"Experience"} top="50px" id={"experience"} />
      <BigText text={"Internships"} align="left" top="250px" top2="220px" />
      <AddExp
        role={"Software Engineer Trainee"}
        company={"The Ksquare Group"}
        description={
          "Working as a Software Engineer Trainee, mainly focusing on Salesforce development and CRM application development."
        }
        from={"Feb 2025"}
        to={"Present"}
        location={"Hyderabad, India"}
        type={"On-site"}
      />
      <AddExp
        role={"Full Stack Developer"}
        company={"Wellytics"}
        description={
          "Developed a full stack application for a health and wellness startup. The application allows users to track their health and wellness progress."
        }
        from={"Apr 2024"}
        to={"Dec 2024"}
        location={"Hyderabad, India"}
        type={"Remote"}
      />
      <GlowShade
        color="#00A86B"
        top="55%"
        left="-4%"
        height="200px"
        width="200px"
      />
      <AddExp
        role={"Full Stack Developer"}
        company={"Enligence Technologies"}
        description={
          "Leading development of a Next.js mock interview platform (Pragya) for handsfree AI interviews"
        }
        from={"Feb 2024"}
        to={"Apr 2024"}
        location={"Bangalore, India"}
        type={"On-site"}
      />
      <AddExp
        role={"Assistant Full Stack Developer"}
        company={"Enligence Technologies"}
        description={
          "Developed a custom H5P plugin focused on speech recognition and interaction, enhancing the accessibility and user experience of e-learning platforms."
        }
        from={"Apr 2023"}
        to={"Oct 2023"}
        location={"Bangalore, India"}
        type={"On-site"}
      />
      <AddExp
        role={"Web Developer"}
        company={"Oasis Infobyte"}
        description={
          "Participated in a one-month virtual internship at Oasis Infobyte, gaining exposure in projects"
        }
        from={"Feb 2023"}
        to={"Mar 2023"}
        location={"Online"}
        type={"Remote"}
      />
      <ImageMotion
        image={Ksquare}
        height={"50px"}
        top={"40%"}
        left={"2%"}
        alt={"The Ksquare Group"}
      />
      <ImageMotion
        image={Wellytics}
        height={"70px"}
        top={"60%"}
        left={"1%"}
        alt={"Wellytics"}
      />
      <ImageMotion
        image={Enligence}
        height={"70px"}
        top={"80%"}
        left={"10%"}
        alt={"Enligence Technologies"}
      />
      <ImageMotion
        image={OasisInfobyte}
        height={"120px"}
        top={"110%"}
        left={"5%"}
        alt={"Oasis Infobyte"}
      />
      <GlowShade
        color="#824581"
        top="100%"
        left="80%"
        height="200px"
        width="200px"
        left2="50%"
      />
    </div>
  );
}
